import React, { Component } from 'react';
import { StyleSheet, View, Text, TouchableOpacity, Linking, Image } from 'react-native';
import images from "../../images/ImagesControl";
import { Table } from '../../components/Table';
import { Row, Rows } from '../../components/Rows';

class Content1 extends Component {
    render() {
        return (
            <View>
                <Text style={styles.heading}>
                    {
                        "M18 Search"
                    }
                </Text>
                <Text style={styles.text}>
                    {
                        "The primary purpose for M18 system is to enhance your data management. " +
                        "With M18, Data should be input once to M18 and view it in everywhere."
                    }
                </Text>
                <Text style={styles.subheading}>
                    {
                        "Aim:"
                    }
                </Text>
                <Text style={styles.text}>
                    {
                        "After reading this chapter, you should be able to:"
                    }
                </Text>
                <Text style={[styles.text, { paddingLeft: 20 }]}>
                    {
                        "1.	Retrieve Data from M18"
                    }
                </Text>
                <Text style={[styles.text, { paddingLeft: 20 }]}>
                    {
                        "2.	Obtain Module Record Unique ID"
                    }
                </Text>
                <Text style={styles.subheading}>
                    {
                        "Scenario:"
                    }
                </Text>
                <Text style={[styles.text, { paddingBottom: 20 }]}>
                    {
                        "Chris is IT Manager of ABC Fruit Company. He is responsible for maintaining ABC Fruit Catalog which shows imported fruits and local fruits separately."
                    }
                </Text>
            </View>
        );
    }
}

class Content2 extends Component {
    constructor(props) {
        super(props);

        this.state = {
            heightArr: [40, 40, 40, 40],
            widthArr: [100, 150, 430],
            tableHead: ["Name", "Type", "Description"],
            tableData: [
                ["authorization", "String(Header)", "Required. Access Token obtained via OAuth"],
                ["client_id", "String(Header)", "Required. Client ID in M18 [OAuth Applications]"],
                ["stSearch", "String(Query)", "Required. Lookup type, such as 'employee', can be found in Data Dictionary or UDF Lookup."],
                ["conds", "String(Query)", "Please check Condition Detail (above link)"],
            ],
        }
    }

    render() {
        const state = this.state;

        return (
            <View>
                <Text style={styles.text}>
                    {
                        "Jane, manager from Marketing Department, contacts Chris from time to time for adding different new products. " +
                        "Due to heavy workload on Chris, he often fails to release latest catalog on time. This hindered promotion campaigns proposed by Jane."
                    }
                </Text>
                <Text style={styles.text}>
                    {
                        "Chris decides to solve it by using "
                    }
                    <TouchableOpacity onPress={() => Linking.openURL('http://m18doc.multiable.com/en/m18/m18core_ws.html#data-search-web-service')}>
                        <View>
                            <Text style={styles.hyperlink}>
                                {
                                    "M18 Data Search Web Service"
                                }
                            </Text>
                        </View>
                    </TouchableOpacity>
                </Text>
                <Text style={styles.text}>
                    {
                        "Below is the snapshot for the documentation."
                    }
                </Text>
                <Text style={[styles.text, { fontWeight: 'bold' }]}>
                    {
                        "HTTP Request"
                    }
                </Text>
                <Text style={[styles.text, { color: 'red' }]}>
                    {
                        "GET"
                        + "\n" +
                        "http://[server]/jsf/rfws/search/search?stSearch=[stSearchName]&startRow=[startRow]&endRow=[endRow]"
                    }
                </Text>
                <Text style={[styles.text, { fontWeight: 'bold' }]}>
                    {
                        "Parameters"
                    }
                </Text>
                <Table borderstyle={{ borderWidth: 1 }} style={styles.text}>
                    <Row data={state.tableHead} style={styles.tableCell}
                        widthArr={state.widthArr} textStyle={[styles.tableText, { fontWeight: 'bold' }]} />
                    <Rows data={state.tableData} style={styles.tableCell}
                        widthArr={state.widthArr} textStyle={styles.tableText} heightArr={state.heightArr} />
                </Table>
            </View>
        );
    }
}

class Content3 extends Component {
    render() {
        return (
            <View>
                <Text style={styles.subheading}>
                    {
                        "Understanding stSearch"
                    }
                </Text>
                <Text style={styles.text}>
                    {
                        "M18 Data Search Web Service relies solely on stSearch parameter. " +
                        "stSearch is a searching scheme defined in M18, it covers information of tables, sorting and table joins involved in a search."
                    }
                </Text>
                <Text style={[styles.text, { paddingBottom: 20 }]}>
                    {
                        "You can obtain stSearch by visiting <Lookup> in M18:"
                    }
                </Text>
                <Image source={images.ch3_fig1} style={{ width: 1000, height: 400 }} />
                <Text style={[styles.text, { paddingBottom: 20 }]}>
                    {
                        "M18 provides numerous different stSearch for <Product / Material>. " +
                        "It can be confusing to decide which one should be used. " +
                        "You can get the standard stSearch used in <Product / Material> by visiting <Product / Material> editor. "
                    }
                </Text>
                <Image source={images.ch3_fig2} style={{ width: 801, height: 226 }} />
                <Text style={[styles.text, { paddingBottom: 20 }]}>
                    {
                        "1.	Click [Edit Query]"
                    }
                </Text>
                <Image source={images.ch3_fig3} style={{ width: 867, height: 215 }} />
                <Text style={[styles.text, { paddingBottom: 20 }]}>
                    {
                        "2.	Click [Lookup]"
                    }
                </Text>
                <Image source={images.ch3_fig4} style={{ width: 867, height: 215 }} />
                <Text style={styles.text}>
                    {
                        "3.	The code in brackets is the stSearch we want."
                    }
                </Text>
            </View>
        );
    }
}

class Content4 extends Component {
    constructor(props) {
        super(props);

        this.state = {
            heightArr: [40, 40, 40, 40, 40, 40],
            widthArr: [100, 150, 430],
            tableHead: ["Name", "Type", "Description"],
            tableData: [
                ["authorization", "String(Header)", "Required. Access Token obtained via OAuth"],
                ["client_id", "String(Header)", "Required. Client ID in M18 [OAuth Applications]"],
                ["module", "String(Path)", "Required. Module type, such as 'employee', can be found in Data Dictionary."],
                ["menuCode", "String(Query)", "Menu code of the editor, can be found in Data Dictionary."],
                ["code", "String(Query)", "Required. The code of the record."],
                ["beId", "int(Query)", "If the module is BE specific, need to provide the beID. "
                    + "BE means Business Entity in M18, which is a [Department] record with BE check box ticked."],
            ],
        }
    }

    render() {
        const state = this.state;
        return (
            <View>
                <Text style={styles.subheading}>
                    {
                        "Buildup Search Condition"
                    }
                </Text>
                <Text style={[styles.text, { paddingBottom: 20 }]}>
                    {
                        "Next we need to prepare different product lists which show imported fruits and local fruits respectively. " +
                        "M18 Data Search Web Service allows you to provide a SQL like WHERE clause to filter data."
                    }
                </Text>
                <Image source={images.ch3_fig5} style={{ width: 958, height: 185 }} />
                <Text style={[styles.text, { paddingBottom: 20 }]}>
                    {
                        "Assume [Series] is the field to distinguish product, we need to know its corresponding column name in Database."
                    }
                </Text>
                <Image source={images.ch3_fig6} style={{ width: 372, height: 413 }} />
                <Text style={[styles.text, { paddingBottom: 20 }]}>
                    {
                        "1.	Enable [Show Field Name]"
                    }
                </Text>
                <Image source={images.ch3_fig7} style={{ width: 977, height: 119 }} />
                <Text style={styles.text}>
                    {
                        "2.	Place your cursor on [Series]. “seriesId” is found to be the table column name."
                    }
                </Text>
                <Text style={styles.subheading}>
                    {
                        "Get ID by Code"
                    }
                </Text>
                <Text style={styles.text}>
                    {
                        "After collecting above information, it is easy to come up with the following condition:"
                    }
                </Text>
                <Text style={[styles.text, { fontWeight: 'bold' }]}>
                    {
                        "For imported fruits:"
                    }
                </Text>
                <Text style={[styles.text, { color: 'green' }]}>
                    {
                        "seriesId=equals=IMPORT"
                    }
                </Text>
                <Text style={[styles.text, { fontWeight: 'bold' }]}>
                    {
                        "For local fruits:"
                    }
                </Text>
                <Text style={[styles.text, { color: 'brown' }]}>
                    {
                        "seriesId=equals=LOCAL"
                    }
                </Text>
                <Text style={styles.text}>
                    {
                        "For all lookup fields in M18, we must use record id in build condition. Record id can be obtained by using "
                    }
                    <TouchableOpacity onPress={() => Linking.openURL('http://m18doc.multiable.com/en/m18/m18core_ws.html#get-id-by-code-web-service')}>
                        <View>
                            <Text style={styles.hyperlink}>
                                {
                                    "Get ID by Code Web Service"
                                }
                            </Text>
                        </View>
                    </TouchableOpacity>
                </Text>
                <Text style={[styles.text, { fontWeight: 'bold' }]}>
                    {
                        "HTTP Request"
                    }
                </Text>
                <Text style={[styles.text, { color: 'red' }]}>
                    {
                        "GET"
                        + "\n" +
                        "http://[server]/jsf/rfws/entity/getIdByCode/[module]?menuCode=[menuCode]&code=[record code]"
                    }
                </Text>
                <Table borderstyle={{ borderWidth: 1 }} style={styles.text}>
                    <Row data={state.tableHead} style={styles.tableCell}
                        widthArr={state.widthArr} textStyle={[styles.tableText, { fontWeight: 'bold' }]} />
                    <Rows data={state.tableData} style={styles.tableCell}
                        widthArr={state.widthArr} textStyle={styles.tableText} heightArr={state.heightArr} />
                </Table>
            </View>
        );
    }
}

class Content5 extends Component {
    render() {
        return (
            <View>
                <Text style={[styles.subheading, { paddingBottom: 20 }]}>
                    {
                        'Sample request to find Id of '
                    }
                    <Text style={{ color: 'green' }}>
                        {
                            'Series = “IMPORT”'
                        }
                    </Text>
                    {
                        ' and '
                    }
                    <Text style={{ color: 'brown' }}>
                        {
                            'Series = “LOCAL"'
                        }
                    </Text>
                </Text>
                <View style={styles.border}>
                    <Text style={[styles.text, { paddingLeft: 20 }]}>
                        {
                            "GET"
                            + "\n" +
                            "http://[server]/jsf/rfws/entity/getIdByCode/"
                        }
                        <Text style={[{ color: 'green' }]}>
                            {
                                "series?menuCode=series&code=IMPORT"
                            }
                        </Text>
                    </Text>
                    <Text style={[styles.text, { paddingLeft: 20, paddingBottom: 20 }]}>
                        {
                            "GET"
                            + "\n" +
                            "http://[server]/jsf/rfws/entity/getIdByCode/"
                        }
                        <Text style={[{ color: 'brown' }]}>
                            {
                                "series?menuCode=series&code=LOCAL"
                            }
                        </Text>
                    </Text>
                </View>
                <Text style={[styles.subheading, { paddingBottom: 20 }]}>
                    {
                        "Sample Response"
                    }
                </Text>
                <View style={styles.border}>
                    <Text style={[styles.text, { paddingLeft: 20 }]}>
                        {
                            '{"withMulti":false,'
                        }
                        <Text style={[{ color: 'green' }]}>
                            {
                                '"id":"1"'
                            }
                        </Text>
                        {
                            ',"withRight":true}'
                        }
                    </Text>
                    <Text style={[styles.text, { paddingLeft: 20, paddingBottom: 20 }]}>
                        {
                            '{"withMulti":false,'
                        }
                        <Text style={[{ color: 'brown' }]}>
                            {
                                '"id":"2"'
                            }
                        </Text>
                        {
                            ',"withRight":true}'
                        }
                    </Text>
                </View>
                <Text style={[styles.text, { paddingBottom: 20 }]}>
                    {
                        "Back to the catalog from ABC Fruit Company, we are now ready to query imported fruits and local fruits from M18 directly. By pressing refresh button, you can preview sample request and response."
                    }
                </Text>
            </View>
        );
    }
}

const styles = StyleSheet.create({
    heading: {
        paddingTop: 20,
        fontSize: 30,
        fontWeight: 'bold',
    },
    subheading: {
        paddingTop: 20,
        fontSize: 20,
        fontWeight: 'bold',
    },
    text: {
        paddingTop: 20,
    },
    hyperlink: {
        fontStyle: 'iTalic',
        color: 'blue',
        textDecorationLine: 'underline',
    },
    tableText: {
        margin: 6,
        fontSize: 10
    },
    tableCell: {

    },
    border: {
        borderWidth: 1,
    }
});

export { Content1, Content2, Content3, Content4, Content5 };



// WEBPACK FOOTER //
// ./src/pages/ch3/Content.js